import { UserSignupMethod, UserStatus } from "src/app/enums/Index";
import { GroupUser } from "./GroupUser";
import { Model } from "./Model";
import { UserDevice } from "./UserDevice";

export interface User extends Model {
	avatarUrl?: string;
	emailAddress?: string;
	emailAddressVerificationCode?: string;
	emailAddressVerified: boolean;
	firstName?: string;
	groupUsers?: GroupUser[];
	/**
	 * Convert to a new Date object before use
	 */
	lastLoginDate?: string;
	lastName?: string;
	mobileNumber?: string;
	password?: string;
	/**
	 * Convert to a new Date object before use
	 */
	passwordExpiryDate?: string;
	passwordResetToken?: string;
	/**
	 * Convert to a new Date object before use
	 */
	passwordResetTokenExpiryDate?: string;
	refreshToken?: string;
	/**
	 * Convert to a new Date object before use
	 */
	refreshTokenExpiryDate?: string;
	signUpMethod: UserSignupMethod;
	userDevices?: UserDevice[];
	userStatus: UserStatus;
}

export class User implements User {
	signUpMethod = UserSignupMethod.AdminCreated;
	userStatus = UserStatus.Unverified;

	constructor(data?: Partial<User>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}